import type { ReactNode } from 'react';

import styles from './Chip.module.css';

export type ChipTone = 'neutral' | 'good' | 'warn' | 'bad';

export interface ChipProps {
  tone?: ChipTone;
  /** Read out before the value, so a chip means something without its colour. */
  label?: string;
  children: ReactNode;
}

export function Chip({ tone = 'neutral', label, children }: ChipProps) {
  return (
    <span className={`${styles.chip} ${styles[tone]}`}>
      {label ? <span className={styles.label}>{label}</span> : null}
      {children}
    </span>
  );
}
